import { getProviderFormService, checkModalSubscription } from '../../../helper';
/**
 *
 * @param {object} serviceData
 * @param {object|null} modal
 * @description
 * 1 - Deny link duplicates поддерживают только провайдеры
 * 2 - Subscription и Subscription reselling - не поддеживаем
 * 3 - Subscription и Subscription reselling сервиса (провайдера) - не поддерживаем
 *
 * Subscription ID = 100
 * Subscription reselling ID = 101
 *
 * @returns {boolean}
 */
export default (serviceData, modal) => {
  const isSubscription = checkModalSubscription(modal);
  if (!isSubscription) {
    if (serviceData?.form) {
      const { mode, provider_id, provider_service_id } = serviceData.form;
      const { providerForm } = serviceData;
      if (mode === 1) {
        const service = getProviderFormService(provider_service_id, providerForm);
        if (service) {
          if (service.hasOwnProperty('service_type')) {
            const { service_type } = service;
            if (Number(service_type) === 100 || Number(service_type) === 101) {
              return false;
            }
          }
        }
        if (provider_id) {
          return true;
        }
      }
      if (mode === 0) {
        return true;
      }
    }
  }
  return false;
};
